<template>
  <div>
    <h3 class="mb-15">
      Compétences socio-professionnelles
    </h3>
    <div class="flex flex-col space-y-5">
      <div 
        v-for="(compSocio, iSocio) in criterions"
        :key="iSocio"
        class="flex flex-col space-y-2.5"
      >
        <div
          class="mr-2 pt-4"
          v-if="iSocio > 0 || criterions.length > 1"
        >
          <delete-button
            @del="deleteCompetence(iSocio)"
            libelle="Supprimer la compétence"
          />
        </div>
        <div
          id="competencesSocioForm"
          class="grid grid-cols-6 gap-4"
        >
          <div class="col-span-full md:col-span-3 lg:col-span-2">
            <input-select
              :name="'categoriesSocio'+iSocio"
              libelle="Catégorie et référentiel"
              :datas="referentiel"
              @input="(newValue) => {if(!freezeDatas) getCompetencesAndNiveaux(iSocio, newValue)}"
              :value-is-object="true"
              :value="compSocio.values.categories"
            />
          </div>
          <div class="col-span-full md:col-span-3 lg:col-span-2">
            <multiple-select
              :name="'competencesSocio'+iSocio"
              libelle="Intitulés"
              :datas="compSocio.datas.competences"
              @input="(newValue) => {if(!freezeDatas) setSearching('competences', iSocio, newValue);}"
              :value="compSocio.values.competences"
              :value-is-object="true"
            />
          </div>
          <div class="col-span-full md:col-span-3 lg:col-span-2">
            <input-select
              :name="'niveauxSocio'+iSocio"
              libelle="Niveau (minimum)"
              :datas="compSocio.datas.niveaux"
              @input="(newValue) => {if(!freezeDatas) setSearching('niveaux', iSocio, newValue);}"
              :value="compSocio.values.niveaux"
              :value-is-object="true"
            />
          </div>
        </div>
        <div
          id="tagsCompSocio"
          class="flex flex-wrap space-y-2.5 items-baseline"
        >
          <tag
            v-if="Object.values(compSocio.values.categories).length > 0"
            :libelle="compSocio.values.categories.value"
            theme-color="indigo"
            :is-closeable="true"
            text-size="text-sm"
            text-font="font-light"
            @close="setSearching('categories', iSocio, {});"
            class="mr-2.5"
          />
          <div
            v-for="(comp, icomp) in compSocio.values.competences"
            :key="icomp"
            class="w-full"
          >
            <tag
              :libelle="comp.value"
              theme-color="teal"
              :is-closeable="true"
              text-size="text-sm"
              text-font="font-light"
              @close="deleteTheCompetence(iSocio, icomp);"
              can-truncate
              class="mr-2.5"
            />
          </div>

          <tag
            v-if="Object.values(compSocio.values.niveaux).length > 0"
            :libelle="compSocio.values.niveaux.value"
            theme-color="orange"
            :is-closeable="true"
            text-size="text-sm"
            text-font="font-light"
            @close="setSearching('niveaux', iSocio, {});"
            class="mr-2.5"
          />
        </div>
      </div>
      <div
        id="addCompSocioButton"
      >
        <add-button
          class="hidden sm:flex"
          libelle="Ajouter une compétence socio-professionnelle"
          @add="addCompetence"
        />
        <add-button
          class="sm:hidden"
          libelle=""
          @add="addCompetence"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import axios from './../../../api';

import InputSelect from './../../../components/Inputs/InputSelect.vue';
import AddButton from './../../../components/Inputs/AddButton.vue';
import Tag from './../../../components/Tag.vue';
import DeleteButton from './../../../components/Inputs/DeleteButton.vue';
import MultipleSelect from './../../../components/Inputs/MultipleSelect.vue';

import Constants from './../../../constants';

export default {
  name:'SearchCompetencesSocio',

  components:{
    InputSelect,
    AddButton,
    Tag,
    DeleteButton,
    MultipleSelect,
  },
        
  props:{
    //
  },

  data(){
    return{
      freezeDatas:false,
      constants: Constants
    };
  },

  computed:{
    ...mapGetters({
      referentiels: 'rechercheCompetences/referentiels',
      searching: 'rechercheCompetences/searching',
    }),

    typeCompetence(){
      return Constants.MODULE_NEOPASS_FORM_COMPETENCES_SOCIO_PRO;
    },

    referentiel(){
      return this.referentiels[this.typeCompetence];
    },

    criterions(){
      return this.searching[this.typeCompetence];
    },
  },

  methods:{
    ...mapMutations({
      SET_SEARCHING: 'rechercheCompetences/SET_SEARCHING',
    }),

    /**
         * Add an empty competence personnelle filter
         */      
    addCompetence(){
      this.searching[this.typeCompetence].push(
        {   
          datas: {competences:[], niveaux:[]},
          values: {categories: {}, competences: [], niveaux:{}}
        },
      );
    },

    /**
         * Delete a competence personnelle filter at "index" position
         * @param Number index 
         */
    async deleteCompetence(index){
      this.freezeDatas = true;
      await this.searching[this.typeCompetence].splice(index, 1);

      setTimeout(() => {
        this.freezeDatas = false;
      }, 500);
            
    },

    /**
         * According to filter field type, call method to reset next fields
         * @param String typeSearch 
         * @param Number index 
         * @param Object item 
         */
    setSearching(typeSearch, index, item){
      switch (typeSearch) {
      case 'categories':
        this.setSearchingCategories(index, item);
        break;
            
      case 'competences':
        this.setSearchingCompetences(index, item);   
        break;

      case 'niveaux':
        this.setSearchingNiveaux(index, item);   
        break;

      default:
        break;
      }
    },

    /**
         * When change categorie value, reset all other fields
         * @param Number index 
         * @param Object item 
         * @param Boolean selfReset 
         */
    setSearchingCategories(index, item, selfReset = false){
      this.searching[this.typeCompetence][index].values.categories = item;

      this.setSearchingCompetences(index, [], true);
      this.setSearchingNiveaux(index, {}, true);
    },

    /**
         * reset niveaux after choose a competence, and put empty array value to competence field
         * not reset niveau because, niveaux are generate when choose a category (template page)
         * @param Number index 
         * @param Object item 
         * @param Boolean selfReset 
         */
    setSearchingCompetences(index, item, selfReset = false){
      this.searching[this.typeCompetence][index].values.competences = item;

      if((item === {} || Object.values(item).length === 0 || item.length === 0) && selfReset){
        this.searching[this.typeCompetence][index].datas.competences = [];
      }
    },

    /**
         * put empty array value to niveaux field
         * @param Number index 
         * @param Object item 
         * @param Boolean selfReset 
         */
    setSearchingNiveaux(index, item, selfReset = false){
      this.searching[this.typeCompetence][index].values.niveaux = item;

      if((item === {} || Object.values(item).length === 0 || item.length === 0) && selfReset){
        this.searching[this.typeCompetence][index].datas.niveaux = [];
      }
    },

    /**
         * Load competence and niveaux when choose a category
         * @param Number index 
         * @param Object newCat 
         */
    async getCompetencesAndNiveaux(index, newCat){
      this.setSearchingCategories(index, newCat);
      if(newCat === '' || Object.values(newCat).length === 0){//Nothing if empty value
        return;
      }

      let domainePosition = -1;

      await axios.get('api/recherche/loadCompetences/'+this.searching[this.typeCompetence][index].values.categories.id+'/'+domainePosition).then(response => {
        this.searching[this.typeCompetence][index].datas.competences = response.data;
      });

      let position = -1;

      await axios.get('api/recherche/loadNiveaux/'+this.searching[this.typeCompetence][index].values.categories.id+'/'+position+'/'+position).then(response => {
        this.searching[this.typeCompetence][index].datas.niveaux = response.data;
      });
    },
        
    /**
         * Delete only one competence among multi selection
         * @param Number indexCriterions 
         * @param Number indexCompetence 
         */
    deleteTheCompetence(indexCriterions, indexCompetence){
      this.searching[this.typeCompetence][indexCriterions].values.competences.splice(indexCompetence, 1);
    }
  },

  watch: {
    //
  },    
};
</script>